import React, { useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Tag } from 'primereact/tag';
import { assignOrders, fetchOrder, fetchOrders, fetchRiders } from '../apis/orders';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { useMediaQuery } from 'react-responsive';
// import { Card } from 'primereact/card';
// import { Divider } from 'primereact/divider';
// import { Image } from 'primereact/image';
// import { Panel } from 'primereact/panel';
import toast, { Toaster } from 'react-hot-toast';
import { Dialog } from 'primereact/dialog';
// import { OrderDetailsSidebar } from './OrderDetailsSidebar.tsx';
import OrderDetailsSidebar from './OrderDetailsSidebar.tsx';

export default function OrdersPage() {
    const filterChange = useMediaQuery({ maxWidth: 768 });
    const orderLimit = 15
    const [orders, setOrders] = useState([]);
    const [globalFilter, setGlobalFilter] = useState('');
    const [selectedOrder, setSelectedOrder] = useState(null);
    // const [rowClick, setRowClick] = useState(true);
    const [visible, setVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [first, setFirst] = useState(0);
    const [appliedStatus, setAppliedStatus] = useState('');
    const [appliedDeliveryType, setAppliedDeliveryType] = useState('');
    const [totalPage, setTotalPage] = useState(0);
    const [order, setOrder] = useState();

    const [dialogVisible, setDialogVisible] = useState(false);
    const [riders, setRiders] = useState([]);
    const [ridersLoading, setRidersLoading] = useState(false);
    const openDialog = () => setDialogVisible(true);
    const hideDialog = () => {
        setDialogVisible(false);
        setRidersLoading(false);
    }

    const [statusFilter, setStatusFilter] = useState('');
    const statusOptions = [
        { label: 'CONFIRMED', value: 'CONFIRMED' },
        { label: 'PACKED', value: 'PACKED' },
        { label: 'PICKED', value: 'PICKED' },
        { label: 'DELIVERED', value: 'DELIVERED' },
    ];

    const [deliveryTypeFilter, setDeliveryTypeFilter] = useState('');
    const deliveryTypeOptions = [
        { label: 'EXPRESS', value: 'EXPRESS' },
        { label: 'STANDARD', value: 'STANDARD' },
    ];

    const handleApplyFilter = async () => {
        setAppliedStatus(statusFilter);
        setAppliedDeliveryType(deliveryTypeFilter);
        if (statusFilter.length === 0 && deliveryTypeFilter.length === 0) {
            console.log('59 - dont search');
            // toast.current.show({ severity: 'error', summary: 'Please Select a filter', life: 3000 });

            toast.error('Please Select a filter', {
                position: 'top-right' // Other options: 'top-left', 'bottom-left', 'bottom-right'
            });
        } else {
            setFirst(0);
            getOrders(0, statusFilter, deliveryTypeFilter, orderLimit);
        }
    };

    const handleClearFilter = async () => {
        setStatusFilter('');
        setDeliveryTypeFilter('');
        setAppliedStatus('');
        setAppliedDeliveryType('');
        setFirst(0);
        getOrders(0, '', '', orderLimit);
    };

    const assignDelivery = async () => {

        if (selectedOrder === null || selectedOrder.length === 0) {
            toast.error('Please select a Order to assign!');
        } else {
            for (const order of selectedOrder) {
                // if (order.deliveryType != 'STANDARD' || order.riderId != null) {
                if (order.riderId != null) {
                    toast.error('Please select only Unassigned Order!');
                    return;
                }
            };
            setRidersLoading(true);
            openDialog();
            const riders = await fetchRiders();
            setRiders(riders);
            setRidersLoading(false);
        }
    }


    const assignDeliverytoRider = async (riderId) => {
        try {
            if (selectedOrder === null || selectedOrder.length === 0) {
                toast.error('Please select a Order to assign!');
            } else {
            const orderIds = [];
                for (const order of selectedOrder) {

                    // if (order.deliveryType != 'STANDARD') {
                    if (order.riderId != null) {
                        toast.error('Skipping already assigned orders!');
                        // return;
                    } else {
                        orderIds.push(order.orderId);
                    }
                };
                setRidersLoading(true);
                console.log(riderId);

                if (orderIds.length > 0) {
                    await assignOrders(riderId, orderIds);
                    toast.success('Assigning');
                    // setRidersLoading(false);
                    toast.success('Order Assigned to selected Rider');

                    hideDialog();

                    setTimeout(() => {
                        getOrders(first / orderLimit, appliedStatus, appliedDeliveryType, orderLimit);
                    }, 1000);
                } else {
                    toast.success('Selected Orders are already Assigned');
                }

            }
        } catch (error) {
            toast.error('Error Assigning Order');
        }
    };

    const getOrder = async (e) => {
        console.log('135- Sidebar Opening');
        console.log(e);
        const orderId = e.data['orderId'];

        setLoading(true);

        if (e.data != null) {
            console.log('142');
            console.log(orderId);

            // setTimeout(async () => {
            const order = await fetchOrder(orderId);

            console.log('139 - after fetching order');
            console.log(order);

            console.log(typeof order);

            if (typeof order !== Object) {
                setOrder(null);
                console.log('93');
            }

            setOrder(order);
            // }, 5000);
        } else {
            // console.log(rowClick);
            console.log(e.data);
        }

        setLoading(false);
    }

    const getOrders = async (page, status, delivery, limit = orderLimit) => {

        try {
            setLoading(true);
            const orders = await fetchOrders(page, status, delivery, limit);

            if (orders.length === 0) {
                setOrders(orders);
                setTotalPage(0);
                return;
            }

            setTotalPage(parseInt(orders[0]['size']));
            setOrders(orders);

        } catch (error) {
            // setOrderError('Error fetching Orders');
            console.error("Error fetching Orders: ", error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        getOrders(0, '', '', orderLimit);
    }, []);

    const onPage = async (event) => {
        setFirst(event.first);
        getOrders(event.page, appliedStatus, appliedDeliveryType, orderLimit);
    };

    // const formatCurrency = (value) => {

    //     console.log(180);
    //     console.log(value);



    //     return value.toLocaleString('en-US', { style: 'currency', currency: 'INR' });
    // };

    // const priceBodyTemplate = (order) => {
    //     console.log(order);

    //     return formatCurrency(order.orderTotal);
    // };

    const statusBodyTemplate = (order) => {
        return <Tag value={order.status} severity={getSeverity(order)}></Tag>;
    };

    // const getAddressFromCoords = async (lat, lng) => {
    //     const url = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}`;

    //     const response = await fetch(url, {
    //         headers: { 'User-Agent': 'YourAppName/1.0' } // Required by Nominatim
    //     });

    //     const data = await response.json();
    //     return data.display_name;
    // };

    // const addressBodyTemplate = (rowData) => {
    //     const location = rowData.location;

    //     if (!location) return 'No Location';

    //     const lat = location._latitude;
    //     const lng = location._longitude;


    //     // await getAddressFromCoords(lat, lng)
    //     //     .then(address => console.log('Address:', address))
    //     //     .catch(error => console.error(error));

    //     // You can call reverse geocoding here (not recommended in render!)
    //     return <span>{lat}, {lng}</span>;
    // };


    const getSeverity = (order) => {
        switch (order.status) {
            case 'CONFIRMED':
                return 'warning';

            case 'PACKED':
                return 'primary';

            case 'DELIVERED':
                return 'success';

            default:
                return null;
        }
    };

    const onRowSelect = (event) => {
        setVisible(true);
        console.log('246 - row select');
        getOrder(event);
        // toast.current.show({ severity: 'info', summary: 'Product Selected', detail: `Name: ${event.data.username}`, life: 3000 });
    };

    const onRowUnselect = (event) => {
        setVisible(false);
        setSelectedOrder(null);
        // toast.current.show({ severity: 'warn', summary: 'Product Unselected', detail: `Name: ${event.data.username}`, life: 3000 });
    };

    return (
        <>
            <Toaster />
            {/* <div style={{ display: 'flex', flexDirection: 'column' }} className="card h-screen overflow-auto"> */}
            <div className="card">
                {/* <h2 style={{ marginBlock: '1rem' }}>All Orders</h2> */}
                <div className="flex flex-row gap-3 mb-2 filters">
                    {/* <InputText placeholder="Search..." value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} /> */}
                    <Dropdown value={statusFilter} options={statusOptions} onChange={(e) => setStatusFilter(e.value)} placeholder="Status" />
                    <Dropdown value={deliveryTypeFilter} options={deliveryTypeOptions} onChange={(e) => setDeliveryTypeFilter(e.value)} placeholder="Delivery Type" />
                    <Button icon={filterChange ? "pi pi-check" : ""} label="Apply" severity='success' onClick={handleApplyFilter} />
                    <Button icon={filterChange ? "pi pi-times" : ""} label="Clear" severity="danger" onClick={handleClearFilter} />
                </div>
                <div>
                    <Button icon={"pi pi-truck"} className='mb-2 mt-2' label="Assign Delivery" severity="info" onClick={assignDelivery} />
                </div>
                <div className='flex-1'>
                    <DataTable value={orders} lazy paginator rows={orderLimit} totalRecords={totalPage} first={first} onPage={onPage} loading={loading} loadingIcon="pi pi-spin pi-cog" emptyMessage={!loading ? `No orders found` : null} tableStyle={{ minWidth: '50rem' }} selection={selectedOrder} onSelectionChange={(e) => {
                        setSelectedOrder(e.value);
                        // getOrder(e);
                        // console.log(e);
                    }}

                        onRowSelect={onRowSelect} onRowUnselect={onRowUnselect} scrollable scrollHeight={filterChange ? '60vh' : '75vh'} globalFilter={globalFilter} paginatorTemplate="PrevPageLink NextPageLink CurrentPageReport"
                        currentPageReportTemplate="Total Orders: {totalRecords}">
                        <Column selectionMode="multiple" headerStyle={{ width: '3rem' }}></Column>
                        <Column field="orderId" header="Order Id"></Column>
                        <Column field="deliveryType" header="Delivery Type"></Column>
                        <Column field="status" header="Status" body={statusBodyTemplate}></Column>
                        <Column field="riderId" header="Rider Assigned" body={(rowData) => (
                            rowData.riderId == null ? <span>No</span> : <span>Yes</span>
                        )}></Column>
                        <Column field="createdAt" header="Date" sortable></Column>
                    </DataTable>
                </div>
            </div>

            <OrderDetailsSidebar
                visible={visible}
                onHide={() => setVisible(false)}
                order={order}
                loading={loading}
            />

            {/* 
            <Sidebar visible={visible} onHide={() => {
                setVisible(false);
                // setSelectedOrder(null);
            }} position="right" style={{ width: '25rem' }}>
                <div className="p-4">
                    <h2 className="mb-3 text-primary">🧾 Order Details</h2>

                    {loading ? (
                        <>
                            < i className="pi pi-spin pi-cog" style={{ fontSize: '2rem' }}></i>
                        </>

                    ) : order ? (
                        <>
                            <div className="mb-3">
                                <span className="font-bold text-900">Order ID: </span>
                                <Tag value={order.orderId} severity="info" className="ml-2" />
                            </div>

                            <div className="mb-3">
                                <span className="font-bold text-900">Total Amount: </span>
                                <Tag value={`₹${order.orderTotal}`} severity="success" className="ml-2" />
                            </div>
                            <div className="mb-3">
                                <span className="font-bold text-900">Sub Total: </span>
                                <Tag value={`₹${order.subTotal}`} severity="success" className="ml-2" />
                            </div>
                            <div className="mb-3">
                                <span className="font-bold text-900">Delivery Price: </span>
                                <Tag value={`₹${order.deliveryPrice}`} severity="success" className="ml-2" />
                            </div>
                            <div className="mb-3">
                                <span className="font-bold text-900">Platform Fee: </span>
                                <Tag value={`₹${order.platformFee || 0}`} severity="success" className="ml-2" />
                            </div>
                            {
                                order.promoCode == null ? (
                                    <div className="mb-3">
                                        <span className="font-bold text-900">Promo Code: </span>
                                        <Tag value={`None`} severity="success" className="ml-2" />
                                    </div>
                                ) : (
                                    <div className="mb-3">
                                        <span className="font-bold text-900">Promo Code: </span>
                                        <Tag value={`₹${order.promoCode}`} severity="success" className="ml-2" />
                                    </div>
                                )
                            }
                            <div className="mb-3">
                                <span className="font-bold text-900">Discount: </span>
                                <Tag value={`₹${order.discount}`} severity="success" className="ml-2" />
                            </div>
                            <Divider />
                            <Panel header='📍 Delivery Address' toggleable className="mb-3">
                                <p className="m-0 text-700">
                                    {order.address["House no / Flat / Building name"]}, {order.address["Locality / Area / Sector"]}, {order.address.City} - {order.address.Pincode}
                                </p>
                            </Panel>

                            <Divider />
                            <h3 className="mb-1 text-xl">🛍 Items</h3>

                            <div className="flex flex-column gap-3">
                                {order.orderProducts.map((item, index) => (
                                    <Card key={index} className="p-0 border-round shadow-2">
                                        <div className="flex align-items-center gap-3">
                                            <Image
                                                // src={`data:image/jpeg;base64,${item.productImage}`}
                                                src={item.productImage}
                                                alt={item.productName}
                                                width="100"
                                                height='80'
                                                onError={(e) => e.target.src = '/image.png'}
                                            // preview
                                            />
                                            <div className="flex flex-column gap-1">
                                                <span className="text-lg font-semibold text-900">{item.productName}</span>
                                                <span className="text-sm text-700">
                                                    {item.productQuantity} x <Tag severity="warning" value={`${item.numberofItems} Items`}></Tag>
                                                </span>
                                                <span className="text-sm font-medium text-green-600">
                                                    ₹{item.productPrice} x {item.numberofItems} = ₹{item.total}
                                                </span>
                                            </div>
                                        </div>
                                    </Card>
                                ))}
                            </div>
                        </>
                    ) : (<p>Not found</p>)}
                </div>
            </Sidebar > */}

            <Dialog header='Assign Delivery to Rider' visible={dialogVisible} onHide={hideDialog}>

                <DataTable value={riders} lazy paginator rows={riders.length} loading={ridersLoading} loadingIcon="pi pi-spin pi-cog" emptyMessage={!loading ? `No Riders found` : null} tableStyle={{ minWidth: '50rem' }}
                    scrollable scrollHeight={filterChange ? '60vh' : '70vh'}
                >
                    <Column field="name" header="Name"></Column>
                    <Column field="phoneNumber" header="Phone Number"></Column>
                    <Column field="address" header="Location"></Column>
                    <Column header="Action" body={(rowData) => (
                        <Button icon="pi pi-plus" label="Assign" tooltip='Assing Order to this Rider' size='small' severity='success' onClick={() => assignDeliverytoRider(rowData.riderId)} />
                    )}></Column>
                </DataTable>
            </Dialog>
        </>
    );
}
